<template>
  <calling-api path="/api/w/masterData" :once="true">
    <md-autocomplete v-model="selectedItem"
                     @md-changed="handleTermChanged"
                     @md-selected="handleItemSelected"
                     @md-opened="handleOpened"
                     :md-options="items">
      <label v-if="label">{{label}}</label>

      <template class = "selection" slot="md-autocomplete-item" slot-scope="{ item, term }">
        <md-tooltip md-delay="50">
          {{item.yardPostalCode}} {{item.yardRegion}} {{item.yardCity}} {{item.yardStreet}}
        </md-tooltip>
        <md-highlight-text :md-fuzzy-search="false" :md-term="term">{{item.tagId}}-{{ item.tagName }}({{item.yardPostalCode}} {{item.yardRegion}}
          {{item.yardCity}} {{item.yardStreet}})
        </md-highlight-text>
      </template>

      <template slot="md-autocomplete-empty" slot-scope="{ term }">
        No item matching "{{ term }}" were found, please enter at least 3 letters.
      </template>

    </md-autocomplete>
  </calling-api>
</template>


<style scoped>
  .selection {
    min-width: 1200px;
  }


</style>

<script>
  import { mapGetters } from 'vuex';
  import _ from 'underscore';
  import lazy from 'lazy.js';
  //import api from "../api";
  import { newAPIPost } from '../api/index.js'; 

  const lazySearch = _.debounce(
    (vueInstance, term) => {
      console.log(`start lazy`);
      vueInstance.items = new Promise((resolve) => {
        if (term.length > 2) {
          const searchTerm = term.toLowerCase();
          const results = lazy(vueInstance.masterDatas)
            .filter((it) => {
              return it.tagId.toLowerCase()
                  .indexOf(searchTerm) > -1
                || it.tagName.toLowerCase()
                  .indexOf(searchTerm) > -1
                || (!!it.yardPostalCode && it.yardPostalCode.toLowerCase()
                  .indexOf(searchTerm) > -1)
                || (!!it.yardRegion && it.yardRegion.toLowerCase()
                  .indexOf(searchTerm) > -1)
                || (!!it.yardCity && it.yardCity.toLowerCase()
                  .indexOf(searchTerm) > -1)
                || (!!it.yardStreet && it.yardStreet.toLowerCase()
                  .indexOf(searchTerm) > -1);
            })
            .take(10)
            .value();
          resolve(results);
        } else {
          resolve([]);
        }
      });
    },
    500,
  );
  export default {
    props: {
      label: String,
      group: String,
      value: String,
      preparedOptions: Array,
      onItemSelected: Function,
    },
    data: () => ({
      selectedItem: '',
      masterDatas: [],
      items: [],
    }),
    computed: {
      ...mapGetters([
        'getMasterDataAsSelectOptionByGroup',
      ]),
    },
    watch: {
      value: {
        handler(newValue) {
          this.selectedItem = newValue;
        },
        immediate: true,
      },
      selectedItem(item) {
        if (item && _.isObject(item)) {
          this.selectedItem = item.tagId;
          this.$emit('input', item.tagId);
        }
        if (!item || item === '') {
          this.onItemSelected(null);
        }
      },
      group: {
        async handler(newVal, oldVal) {
          if (newVal !== oldVal && !!newVal) {
            //this.selectedItem = '';

          const cache = this.getMasterDataAsSelectOptionByGroup(newVal);
          if (cache == null)
          {
            //this.masterDatas = await api.post('/api/w/masterData', { groups: [newVal] });
            this.masterDatas = await newAPIPost('/api/w/masterData', { groups: [newVal] });
          }
          else
          {
            this.masterDatas = cache;
          }
            
           
          }
        },
        immediate: true,
      },

      

      


    },
    methods: {
      clear() {
        this.selectedItem = '';
      },
      handleTermChanged(term) {
        if (this.selectedItem && term !== this.selectedItem) {
          this.selectedItem = '';
        }
        lazySearch(this, term);
      },
      handleItemSelected(item) {
        if (this.onItemSelected) {
          this.onItemSelected(item);
        }
      },
      handleOpened() {
        this.selectedItem = '';
      },
    },
  };
</script>
